module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "h1"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "hanging",
    staticStyle: {
      "padding-top": "3%"
    }
  }, [_vm._v("(Cases considered at length are printed in roman)")]), _vm._v(" "), _c('p', {
    staticClass: "hanging",
    staticStyle: {
      "padding-top": "3%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/03_acknowledgements#h2"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging",
    staticStyle: {
      "padding-top": "3%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#h3"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "first",
    staticStyle: {
      "padding-left": "5%",
      "text-indent": "0%"
    }
  }, [_c('i', [_vm._v("Robert Irwin—The artist and the criminal")]), _vm._v("—Raymond Morris and the Cannock Chase murder—"), _c('i', [_vm._v("Kürten—Leopold and Loeb.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging",
    staticStyle: {
      "padding-top": "3%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/05_chapter01#h4"
    }
  }, [_vm._v("1. THE BEGINNINGS")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Violence as protest against civilisation—The Crusades—Sawney Bean and his family—Torture—The execution of Damiens—Statistics of murder in past centuries—Gilles de Rais—Elizabethan domestic tragedy—Walter Calverley")]), _vm._v("—Thomas Arden of Faversham—"), _c('i', [_vm._v("The Max Garvie case—The murder of George Sanders—Francis Thorney—The murder of Christopher Marlowe—Was Marlowe Shakespeare?—Execution of Dr Lopez—Amy Robsart—Sir Thomas Malory, rapist and bandit—Gesualdo, composer and wife murderer—Murder of Sir Thomas Overbury—Murder of Sir Edmund Berry Godfrey.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging",
    staticStyle: {
      "padding-top": "3%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/06_chapter02#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. THE AGE OF GIN")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Gin and the rising crime rate—The Mohocks—Dick Turpin—Sarah Malcolm and Hogarth—Tyburn tree—History of hanging—Jack Ketch—Marwood—‘Laughing Jack’ Hooper—John Price—‘The Newgate Calendar’")]), _vm._v("—Catherine Hayes—"), _c('i', [_vm._v("Mrs Brownrigg—The Metyards—Trial of the smugglers for murder of Galley and Chater—Earl Ferrars, last nobleman to be publicly hanged—Captain John Porteous—Criminals who survived hanging—Thomas Colley—Henry Fielding and penal reform.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging",
    staticStyle: {
      "padding-top": "3%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/07_chapter03#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. CANNIBALS AND RAPISTS")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Calhoun’s criminal rats—The nineteenth century—Transportation to Australia—Jeffries the Monster—Cannibalism—Alexander Pierce—Dignum and Cornerford—The bushranger Morgan—Arthur Thistlewood and the Cato Street conspirators—Abduction and rape of heiresses—Rape of Sarah Woodcock—Luke Dillon and Miss Frizell—George Cant and Jane Bolland—False allegations of rape—The Red Barn murder")]), _vm._v("—Ellie Hanley, the Colleen Bawn.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging",
    staticStyle: {
      "padding-top": "3%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/08_chapter04#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. INTO THE AGE OF VIOLENCE")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("‘Motiveless joy-murder’—Journals of the Nuremberg hangman, Franz Schmidt—Andrew Bichel, the Bavarian ripper—Martin Dumollard, the mass murderer of Lyons—The Ratcliffe Highway murders—Burke and Hare, the body snatchers—Parisian crime—Vidocq, Balzac’s Vautrin")]), _vm._v("—Lacenaire—"), _c('i', [_vm._v("Thomas Griffiths Wainewright—Female poisoners: Gesina Gottfried, Hélène Jegado, Anna Zwanziger: ‘Poison is my truest friend’—Dr Palmer of Rugely")]), _vm._v("—Thomas Neill Cream—"), _c('i', [_vm._v("George Chapman")]), _vm._v("—Jack the Ripper—"), _c('i', [_vm._v("My own ‘search for Jack the Ripper’—Tessnov, the journeyman ripper—Mervyn Garvie, the Sydney rapist—The rape of Marjory Fenwick—Robert J Thompson—The Texarcana murderer.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging",
    staticStyle: {
      "padding-top": "3%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/09_chapter05#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. THE AGE OF DETECTION")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Scientific crime fighting—Invention of photography—Billoir, the wife murderer")]), _vm._v("—Pierre Voirbo—"), _c('i', [_vm._v("Charles Avinain—Alphonse Bertillon and the classification of criminals—Ravachol, the anarchist—William Herschel and the discovery of fingerprints—First fingerprint murder: Francesca Rojas—Edward Richard Henry, and fingerprint classification—Charan, the Bengali murderer—The first English fingerprint murder: the Stratton brothers of Deptford—Identification of bloodstains")]), _vm._v("—Theodore Berger and the murder of Lucie Berlin—"), _c('i', [_vm._v("Karl Hussmann, the homosexual killer—Edmund Pook and the murder of Jane Clouson")]), _vm._v("—Lizzie Borden; "), _c('i', [_vm._v("the new solution")]), _vm._v("—Miles Giffard.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging",
    staticStyle: {
      "padding-top": "3%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/10_chapter06#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. CHAMBER OF HORRORS")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Rouse, the burning car murderer—Rising crime rate")]), _vm._v("—Jesse Pomeroy—H H Holmes and Nightmare Castle—"), _c('i', [_vm._v("A case of rape in a train crash—The case of Jan and Ada—Crimes of ‘compulsion’—Torture-murder of Alice Porter—Mary Bell, 11-year-old killer—The lesbian murders: Jeannace Freeman and Gertrude Jackson—Hickock and Smith")]), _vm._v("—Ed Gein, the Wisconsin necrophile—"), _c('i', [_vm._v("Carl Folk: the rape of Betty Allen—Charles Schmid—Lloyd Higdon—The Moors murder case, Ian Brady and Myra Hindley—Melvin Rees and the murder of the Jackson family—Richard Speck and the murder of the eight nurses—Norman Smith, the sniper—Klaus Gosmann, the midday murderer")]), _vm._v("—Lucian Staniak, a modern Polish ripper, ‘the Red Spider’—"), _c('i', [_vm._v("Homosexual murderers—Stephen Weinstein—Ralph Nuss—Myron Lance and Walter Kelbach—The Algiers Motel incident—The Armand Rohart case—Ivy Giberson—The Domenech murder case.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging",
    staticStyle: {
      "padding-top": "3%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11_bibliography#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SELECT BIBLIOGRAPHY")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18ee6932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/02_contents.vue
// module id = 66
// module chunks = 0